/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEscalationTicket} from '../api'

 export const useQueryGetEscalationTicket = createReactQueryHook('getEscalationTicket', getEscalationTicket)
